module.exports = __webpack_public_path__ + "img/about-modelling.93f85f80.png";